<div class="container-fluid px-5 py-3">
    <div class="d-flex justify-content-between pb-2">
        <span class="text-blue font-weight-bold">
            <h3 class="my-2" translate>listPromoCampaignConfig.title</h3>
        </span>
    </div>

    <div class="my-2 py-2">
        <!-- Search Form -->
        <form [formGroup]="searchForm">
            <div class="input-group mb-2">
                <!-- service name -->
                <div class="input-group-prepend">
                    <span class="input-group-text" translate>listPromoCampaignConfig.service</span>
                </div>
                <input type="text" class="form-control d-inline" (keyup.enter)="search()" formControlName="serviceName">

                <!-- hasTrigger -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>listPromoCampaignConfig.hasTrigger</span>
                </div>
                <select class="custom-select input-custom-size" formControlName="hasTrigger">
                    <option [ngValue]="null" translate>placeholder.select</option>
                    <option [ngValue]="true" translate>listPromoCampaignConfig.yes</option>
                    <option [ngValue]="false" translate>listPromoCampaignConfig.no</option>
                </select>

                <!-- hasPromoPrice -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>listPromoCampaignConfig.hasPromoPrice</span>
                </div>
                <select class="custom-select input-custom-size" formControlName="hasPromoPrice">
                    <option [ngValue]="null" translate>placeholder.select</option>
                    <option [ngValue]="true" translate>listPromoCampaignConfig.yes</option>
                    <option [ngValue]="false" translate>listPromoCampaignConfig.no</option>
                </select>

                <!-- isActive -->
                <div class="input-group-prepend ml-2">
                    <span class="input-group-text" translate>listPromoCampaignConfig.isActive</span>
                </div>
                <select class="custom-select input-custom-size" formControlName="isActive">
                    <option [ngValue]="null" translate>placeholder.select</option>
                    <option [ngValue]="true" translate>listPromoCampaignConfig.active</option>
                    <option [ngValue]="false" translate>listPromoCampaignConfig.inactive</option>
                </select>

                <!-- actions -->
                <div class="input-group-prepend ml-2">
                    <div style="display: flex;">
                        <button class="btn btn-outline-success" style="border-radius: 0;" type="button" (click)="search()" translate>button.search</button>
                        <button class="btn btn-outline-danger ml-2" style="border-radius: 0;" type="button" (click)="clearSearch()" translate>button.clear</button>
                        <button class="btn btn-outline-success ml-2" style="border-radius: 0;" routerLink="/add-edit-promo-campaign" type="button" translate>button.add</button>
                    </div>
                </div>
            </div>
        </form>

        <br>

        <!-- Table -->
        <div class="d-flex justify-content-center">
            <table class="table table-bordered table-striped w-100" [hidden]="!dataLoaded">
                <thead>
                    <tr>
                        <th translate>listPromoCampaignConfig.service</th>
                        <th translate>listPromoCampaignConfig.hasPromoText</th>
                        <th translate>listPromoCampaignConfig.hasTrigger</th>
                        <th translate>listPromoCampaignConfig.triggerService</th>
                        <th translate>listPromoCampaignConfig.isActive</th>
                        <th translate>listPromoCampaignConfig.actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let config of content">
                        <td>{{config.service?.name}}</td>
                        <td>
                            <ng-container *ngIf="config.hasPromoPrice;">
                                <span>
                                    {{config.discountValue}}{{config.discountKind === 'P' ? '%' : '€'}}
                                </span>
                                <span *ngIf="config.discountText">{{config.discountText}}</span>
                            </ng-container>
                        </td>
                        <td>
                            <span *ngIf="config.hasTrigger;"><span translate>listPromoCampaignConfig.triggerBadge</span></span>
                        </td>
                        <td>
                            <ng-container *ngIf="config.hasTrigger && config.triggerServices?.length;">
                                <span *ngFor="let ts of config.triggerServices; let last = last">{{ts.name}}<ng-container *ngIf="!last">, </ng-container></span>
                            </ng-container>
                        </td>
                        <td>
                            <span *ngIf="config.isActive" translate>listPromoCampaignConfig.active</span>
                            <span *ngIf="!config.isActive" translate>listPromoCampaignConfig.inactive</span>
                        </td>
                        <td class="text-center py-2">
                            <button class="btn btn-sm btn-success" routerLink="/add-edit-promo-campaign"
                                data-toggle="tooltip" data-placement="bottom" title="{{'button.edit' | translate}}"
                                [queryParams]="{id: config.id}">
                                <i class="fa fa-pencil fa-lg"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <ng-container *ngIf="dataLoaded; else dataLoadingTemplate"></ng-container>

        <!-- Pagination -->
        <div class="paging-wrapper d-flex justify-content-between">
            <select class="pagination-size custom-select" [(ngModel)]="sortingPaging.pageSize" (change)="onPageSizeChange($event)">
                <option *ngFor="let item of pageSizeOptions; let i = index" [value]="pageSizeOptions[i]">
                    {{pageSizeOptions[i]}} {{'paging.itemsPerPage' | translate}}
                </option>
            </select>
            <ngb-pagination class="pagination-control"
                [(page)]="sortingPaging.pageNumber"
                [pageSize]="sortingPaging.pageSize"
                [collectionSize]="sortingPaging.totalElements"
                [boundaryLinks]="true"
                [maxSize]="maxSize"
                (pageChange)="pageChanged($event)">
            </ngb-pagination>
            <span class="pagination-index border center">
                {{sortingPaging.fromRow}} - {{sortingPaging.toRow}} / {{sortingPaging.totalElements}}
            </span>
        </div>
    </div>
</div>

<ng-template #dataLoadingTemplate>
    <div *ngIf="errorMessage$ | async as errorMessage; else dataSpinner">
        <div class="alert alert-danger">
            {{errorMessage}}
        </div>
        <div class="d-flex justify-content-center">
            <i class="fa fa-refresh" (click)="reload()"></i>
        </div>
    </div>
    <ng-template #dataSpinner>
        <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </ng-template>
</ng-template>
